<div *ngIf="(siteStateService.state$ | async)?.progress" class="progress" @transform>
    <div class="line-primary"></div>
    <div class="line-secondary"></div>
</div>
